import React from 'react';
import EliasBackButton from '../../../atoms/EliasBackButton/EliasBackButton';
import ROUTER_URLS from '../../../utils/router/urls';
import Dashboard from '../../../compounds/Dashboard/Dashboard';
import { fetchNcaaWbbPlayerStreakStats } from '../../../../api/ncaawbb';
import PlayerStreakFilters from '../../../compounds/PlayerStreakFilters/PlayerStreakFilters';
import ResultsLoading from '../../../compounds/ResultsLoading/ResultsLoading';
import PlayerStreakTable from '../../../compounds/PlayerStreakTable/PlayerStreakTable';
import { statsFilters, streakRangeOptions, PAGE_TITLE, PAGE_SUBTITLE } from './constants';
import EliasStatsFilter from '../../../compounds/EliasStatsFilter/EliasStatsFilter';
import API_URLS from '../../../../api/api_urls';
import ModalFilters from '../../../compounds/ModalFilters/ModalFilters';
import { advancedModalFilterCategories } from '../constants';
import { ContextFilterType } from '../../../types/context';
import NcaaWbbPlayerFiltersLayout from '../../../compounds/ncaawbb/NcaaWbbPlayerFiltersLayout';
import { mapRows } from '../../../utils/ncaawbb/streak-finder/map-results';
import { mapColumns } from '../../../utils/ncaawbb/streak-finder/map-columns';
import FinderStackLayout from '../../../compounds/FinderStackLayout/FinderStackLayout';
import withResultsLayout, { WithResultsLayoutProps } from '../../../compounds/ResultsWrapper/ResultsWrapper';
import { appendContextFilters } from '../../../utils/ncaawbb/search';
import Header from '../../../compounds/Common/Header';
import EXTERNAL_URLS from '../../../utils/router/external_urls';
import NcaaWbbDataInfoModal from '../../../compounds/ncaawbb/NcaaWbbDataInfoModal';
import { FINDER_TYPES } from '../../../utils/common/constants';

interface IProps extends WithResultsLayoutProps {};

function PlayerStreakFinderResults({
  columnHeaders,
  resultsData,
  tableDataLoading,
  filtersLoading,
  error,
  handleDone,
  pageOrSortDataFetch
}: IProps) {
  const pageSpecificSearchEnabled = (context: ContextFilterType): boolean =>
    Boolean(context.streakGameNumber) && Number(context.streakGameNumber) > 1;

  const statsFilterPartial = <EliasStatsFilter statsFilterOptions={statsFilters} displayYearInfo={false} />;
  const bottomModalPartial = (
    <ModalFilters
      buttonTitle='Advanced Filters'
      filters={advancedModalFilterCategories}
      filterType='advancedFilters'
      finderType={FINDER_TYPES.PLAYER_STREAK}
    />
  );

  return (
    <Dashboard loading={filtersLoading}>
      <FinderStackLayout
        header={
          <Header
            title={PAGE_TITLE}
            subtitle={PAGE_SUBTITLE}
            backButton={
              <EliasBackButton route={ROUTER_URLS.ncaawbb.playerStreakFinderSearch} />
            }
          />
        }
        topPanel={
          <NcaaWbbPlayerFiltersLayout
            handleDone={handleDone}
            statsFilterPartial={statsFilterPartial}
            pageSpecificSearchEnabled={pageSpecificSearchEnabled}
            apiUrls={API_URLS.ncaawbb}
            bottomModalPartial={bottomModalPartial}
          >
            <PlayerStreakFilters streakRangeOptions={streakRangeOptions} />
          </NcaaWbbPlayerFiltersLayout>
        }
        bottomPanel={
          tableDataLoading || error ?
          <ResultsLoading error={error} /> :
          <PlayerStreakTable
            data={resultsData?.results ?? []}
            dataCount={resultsData?.count ?? 0}
            dataMetaInfo={resultsData?.query?.back_to ?? []}
            columnData={columnHeaders || []}
            handleDone={pageOrSortDataFetch}
            linkUrls={EXTERNAL_URLS.NCAAW}
            explanationMessage={ <NcaaWbbDataInfoModal /> }
          />
        }
      />
    </Dashboard>
  );
}

export default withResultsLayout(
  PlayerStreakFinderResults,
  ROUTER_URLS.ncaawbb.playerStreakFinderResults,
  statsFilters,
  fetchNcaaWbbPlayerStreakStats,
  mapColumns,
  mapRows,
  appendContextFilters,
  true, // translateNcaawFilters
  FINDER_TYPES.PLAYER_STREAK,
  advancedModalFilterCategories,
);
